import { Recapt } from '../engine';
import { RequestManager } from '../managers/requestManager';
import { BaseEvent, BaseModule } from './base';
import { Namespace } from './types';

interface ActionEvent extends BaseEvent {
  action: string;
}

export class ActionModule extends BaseModule<ActionEvent> {
  public namespace: Namespace = 'actions';

  onAction(action: string) {
    if (action.length > 42) return;

    RequestManager.potentialPainpoint();

    this.state.push({
      timestamp: Recapt.getCurrentSessionTimestamp(),
      action,
      where: Recapt.where(),
    });
  }

  onStart() {
    const stored = this.loadStore<{
      state: ActionEvent[];
    }>();

    if (stored) {
      this.state = stored.state;
    }

    this.store(() => ({
      state: this.state,
    }));
  }

  onResume(): void {}

  onStop() {}

  purgeState(): void {
    this.state = [];
  }

  buildRequest(
    state: ActionEvent[],
  ): Record<string, unknown> & { state: ActionEvent[] } {
    return {
      state,
    };
  }
}
